module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#facebook",
      toString: function () {
        return this.url;
      }
    }